import React, { useRef, useState } from "react"
import { makeStyles } from '@material-ui/core/styles';
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { Checkbox, FormControlLabel } from "@mui/material";

import SignInModal from "./signin";

import { useAuth } from "./firebase/AuthContext";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rounded: {
    borderRadius: "10px",
    border: "none",
  },
}));



const SignUpModal = () => {

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()
  const { currentUser, signup } = useAuth();
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const handleOpen = () => {
    if(!currentUser){
      setOpen(true);
    }else{
      history.push("/workspace")
    }
  };

  const handleClose = () => {
    setOpen(false);
  };


    async function handleSubmit(e) {
      e.preventDefault()

      if (passwordRef.current.value !== passwordConfirmRef.current.value) {
        return setError("Passwords do not match")
      }

    try {

      setError("")
          setLoading(true)
          await signup(emailRef.current.value, passwordRef.current.value);
          history.push("/workspace")
          handleClose();


    } catch {
      signup(emailRef.current.value, passwordRef.current.value).catch(error => {
        switch (error.code) {
           case 'auth/email-already-in-use':
            setError(`Email address already in use.`);
             break;
           case 'auth/invalid-email':
            setError(`Email address is invalid.`);
             break;
           case 'auth/operation-not-allowed':
            setError(`Error during sign up.`);
             break;
           case 'auth/weak-password':
            setError('Password is not strong enough. Add additional characters including special characters and numbers.');
             break;
           default:
            setError(error.message);
             break;
         }
     });
    } 

    setLoading(false)
  

    };

    return (
      <div>
        <Button onClick={handleOpen} style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter' }}>
          Sign Up
        </Button>
        <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
        >
          <Fade in={open}>
          <div className={`${classes.paper} ${classes.rounded}`}>
              <h2 style={{ fontFamily: 'Inter', fontSize: "30px", fontWeight: 'bold' }}>Sign Up</h2>
              <h5 style={{color: 'red'}}>{error}</h5>
              <form className={classes.form} onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  inputRef={emailRef} 
                  required
                  label="Email"
                  sx={{
                    "& fieldset": {
                      border: "none",
                    }
                  }}
                  InputProps={{
                    style: {
                      width: "420px",
                      fontFamily: "'inter",
                      fontStyle: "normal",
                      fontWeight: 700,
                      fontSize: "20px",
                      color: `grey`, 
                      margin:'20px'
                    }
                  }}
                />
                <TextField
  fullWidth
  inputRef={passwordRef}
  required
  label="Password"
  type="password"
  sx={{
    "& fieldset": {
      border: "none",
    }
  }}
  InputProps={{
    style: {
      width: "420px",
      fontFamily: "'inter",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "20px",
      color: `grey`,
      margin: '20px',
      textAlign: "center",
      "&::placeholder": {
        textAlign: "center"
      }
    }
  }}
/>
                <TextField
                  fullWidth
                  inputRef={passwordConfirmRef} 
                  id="Password"
                  required
                  label="Password Confirmation"
                  type="password"
                  sx={{
                    "& fieldset": {
                      border: "none",
                    }
                  }}
                  InputProps={{
                    style: {
                      width: "420px",
                      fontFamily: "'inter",
                      fontStyle: "normal",
                      fontWeight: 700,
                      fontSize: "20px",
                      color: `grey`, 
                      margin:'20px'
                    }
                  }}
                />
                <Button style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', margin:'30px' }}  type="submit">
                  Submit
                </Button>
              </form>
             
            </div>
          </Fade>
        </Modal>
      </div>
    );
};

export default SignUpModal;
